import {
  GET_UNIVERSITIES,
  GET_UNIVERSITIES_FAILURE,
  GET_UNIVERSITIES_SUCCESS,
  GET_UNIVERSITIES_GRID,
  GET_UNIVERSITIES_GRID_SUCCESS,
  GET_UNIVERSITIES_GRID_FAILURE,
  GET_ALL_UNIVERSITIES,
  GET_ALL_UNIVERSITIES_FAILURE,
  GET_ALL_UNIVERSITIES_SUCCESS,
  GET_UNIVERSITY_DETAILS,
  GET_UNIVERSITY_DETAILS_FAILURE,
  GET_UNIVERSITY_DETAILS_SUCCESS,
  GET_UNIVERSITY_DETAILS_ADMIN,
  GET_UNIVERSITY_DETAILS_ADMIN_FAILURE,
  GET_UNIVERSITY_DETAILS_ADMIN_SUCCESS,
  GET_UNIS_BY_BUDGET,
  GET_UNIS_BY_BUDGET_SUCCESS,
  GET_UNIS_BY_BUDGET_FAILURE,
  GET_POPULAR_COUNTRIES,
  GET_POPULAR_COUNTRIES_SUCCESS,
  GET_POPULAR_COUNTRIES_FAILURE,
  GET_UNI_APPS_SHORTS,
  GET_UNI_APPS_SHORTS_SUCCESS,
  GET_UNI_APPS_SHORTS_FAILURE,
  ADD_UNIVERSITY,
  ADD_UNIVERSITY_SUCCESS,
  ADD_UNIVERSITY_FAILURE,
  ADD_UNIVERSITY_SHEET,
  ADD_UNIVERSITY_SHEET_SUCCESS,
  ADD_UNIVERSITY_SHEET_FAILURE,
  EDIT_UNIVERSITY,
  EDIT_UNIVERSITY_SUCCESS,
  EDIT_UNIVERSITY_FAILURE,
  UPLOAD_UNIVERSITY_IMAGES,
  UPLOAD_UNIVERSITY_IMAGES_SUCCESS,
  UPLOAD_UNIVERSITY_IMAGES_FAILURE,
} from "../constants";

export default class UniversityAction {
  static addUniversity(payload, cb) {
    return {
      type: ADD_UNIVERSITY,
      payload,
      cb,
    };
  }
  static addUniversitySuccess(payload) {
    return {
      type: ADD_UNIVERSITY_SUCCESS,
      payload,
    };
  }
  static addUniversityFailure(payload) {
    return {
      type: ADD_UNIVERSITY_FAILURE,
      payload,
    };
  }
  static addUniversitySheet(payload, cb) {
    return {
      type: ADD_UNIVERSITY_SHEET,
      payload,
      cb,
    };
  }
  static addUniversitySheetSuccess(payload) {
    return {
      type: ADD_UNIVERSITY_SHEET_SUCCESS,
      payload,
    };
  }
  static addUniversitySheetFailure(payload) {
    return {
      type: ADD_UNIVERSITY_SHEET_FAILURE,
      payload,
    };
  }
  static editUniversity(payload, cb) {
    return {
      type: EDIT_UNIVERSITY,
      payload,
      cb,
    };
  }
  static editUniversitySuccess(payload) {
    return {
      type: EDIT_UNIVERSITY_SUCCESS,
      payload,
    };
  }
  static editUniversityFailure(payload) {
    return {
      type: EDIT_UNIVERSITY_FAILURE,
      payload,
    };
  }
  static uploadUniImage(payload, cb) {
    return {
      type: UPLOAD_UNIVERSITY_IMAGES,
      payload,
      cb,
    };
  }
  static uploadUniImageSuccess(payload) {
    return {
      type: UPLOAD_UNIVERSITY_IMAGES_SUCCESS,
      payload,
    };
  }
  static uploadUniImageFailure(payload) {
    return {
      type: UPLOAD_UNIVERSITY_IMAGES_FAILURE,
      payload,
    };
  }
  static getUniversities(payload, cb) {
    return {
      type: GET_UNIVERSITIES,
      payload,
      cb,
    };
  }
  static getUniversitiesSuccess(payload) {
    return {
      type: GET_UNIVERSITIES_SUCCESS,
      payload,
    };
  }
  static getUniversitiesFailure(payload) {
    return {
      type: GET_UNIVERSITIES_FAILURE,
      payload,
    };
  }
  static getUniversitiesGrid(payload, cb) {
    return {
      type: GET_UNIVERSITIES_GRID,
      payload,
      cb,
    };
  }
  static getUniversitiesGridSuccess(payload) {
    return {
      type: GET_UNIVERSITIES_GRID_SUCCESS,
      payload,
    };
  }
  static getUniversitiesGridFailure(payload) {
    return {
      type: GET_UNIVERSITIES_GRID_FAILURE,
      payload,
    };
  }
  static getAllUniversities(cb) {
    return {
      type: GET_ALL_UNIVERSITIES,
      cb,
    };
  }
  static getAllUniversitiesSuccess(payload) {
    return {
      type: GET_ALL_UNIVERSITIES_SUCCESS,
      payload,
    };
  }
  static getAllUniversitiesFailure(payload) {
    return {
      type: GET_ALL_UNIVERSITIES_FAILURE,
      payload,
    };
  }
  static getUnisByBudget(cb) {
    return {
      type: GET_UNIS_BY_BUDGET,
      cb,
    };
  }
  static getUnisByBudgetSuccess(payload) {
    return {
      type: GET_UNIS_BY_BUDGET_SUCCESS,
      payload,
    };
  }
  static getUnisByBudgetFailure(payload) {
    return {
      type: GET_UNIS_BY_BUDGET_FAILURE,
      payload,
    };
  }
  static getPopularCountries(cb) {
    return {
      type: GET_POPULAR_COUNTRIES,
      cb,
    };
  }
  static getPopularCountriesSuccess(payload) {
    return {
      type: GET_POPULAR_COUNTRIES_SUCCESS,
      payload,
    };
  }
  static getPopularCountriesFailure(payload) {
    return {
      type: GET_POPULAR_COUNTRIES_FAILURE,
      payload,
    };
  }
  static getUniversityDetails(id, cb) {
    return {
      type: GET_UNIVERSITY_DETAILS,
      id,
      cb,
    };
  }
  static getUniversityDetailsSuccess(payload) {
    return {
      type: GET_UNIVERSITY_DETAILS_SUCCESS,
      payload,
    };
  }
  static getUniversityDetailsFailure(payload) {
    return {
      type: GET_UNIVERSITY_DETAILS_FAILURE,
      payload,
    };
  }
  static getUniversityDetailsAdmin(id, cb) {
    return {
      type: GET_UNIVERSITY_DETAILS_ADMIN,
      id,
      cb,
    };
  }
  static getUniversityDetailsAdminSuccess(payload) {
    return {
      type: GET_UNIVERSITY_DETAILS_ADMIN_SUCCESS,
      payload,
    };
  }
  static getUniversityDetailsAdminFailure(payload) {
    return {
      type: GET_UNIVERSITY_DETAILS_ADMIN_FAILURE,
      payload,
    };
  }
  static getUniAppsShorts(payload, cb) {
    return {
      type: GET_UNI_APPS_SHORTS,
      payload,
      cb,
    };
  }
  static getUniAppsShortsSuccess(payload) {
    return {
      type: GET_UNI_APPS_SHORTS_SUCCESS,
      payload,
    };
  }
  static getUniAppsShortsFailure(payload) {
    return {
      type: GET_UNI_APPS_SHORTS_FAILURE,
      payload,
    };
  }
}
